import React, { PropTypes } from 'react';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';

const MaritalStatus = (props) => {
  return (
    <FormGroup>
      <Col componentClass={ControlLabel} sm={5}>
        Marital Status *
      </Col>
      <Col sm={7}>
        <select
          className="custom-select"
          name="maritalStatus"
          onChange={props.handleChangeMaritalStatus}
          value={props.maritalStatus}
          disabled={props.disabled}
        >
          <option value="Divorced">Divorced</option>
          <option value="Married">Married</option>
          <option value="Single">Single</option>
          <option value="Unknown">Unknown</option>
          <option value="Widowed">Widowed</option>
        </select>
      </Col>
    </FormGroup>
  )
}

MaritalStatus.propTypes = {
  handleChangeMaritalStatus: PropTypes.func,
  maritalStatus: PropTypes.string,
  disabled: PropTypes.bool
};

MaritalStatus.defaultProps = {
  disabled: false,
  required: false
};

export default MaritalStatus;



// WEBPACK FOOTER //
// ./src/app/components/maritalStatus/MaritalStatus.js